// extracted by mini-css-extract-plugin
module.exports = {"PlayerSummary":"PlayerSummary_PlayerSummary__3sb3e","ProfilePicture":"PlayerSummary_ProfilePicture__hzeux","Selections":"PlayerSummary_Selections___6bR4"};